import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface QuizNavArrowsProps {
  canGoPrev: boolean
  canGoNext: boolean
  onPrev: () => void
  onNext: () => void
}

export function QuizNavArrows({
  canGoPrev,
  canGoNext,
  onPrev,
  onNext,
}: QuizNavArrowsProps) {
  const { t } = useTranslation('learner')

  return (
    <>
      {canGoPrev ? (
        <button
          type="button"
          onClick={onPrev}
          aria-label={t('learn.quiz.previous')}
          className="absolute left-5 top-1/2 inline-flex size-12 -translate-y-1/2 items-center justify-center rounded-full border border-lc-v3-gray-300 bg-lc-v3-gray-50 text-[#aaaaaa] transition-colors hover:bg-lc-v3-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lc-key-500"
        >
          <ChevronLeft className="size-6" aria-hidden />
        </button>
      ) : null}

      {canGoNext ? (
        <button
          type="button"
          onClick={onNext}
          aria-label={t('learn.quiz.nextQuestion')}
          className="absolute right-5 top-1/2 inline-flex size-12 -translate-y-1/2 items-center justify-center rounded-full bg-lc-key-500 text-white transition-colors hover:bg-lc-key-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lc-key-500"
        >
          <ChevronRight className="size-6" aria-hidden />
        </button>
      ) : null}
    </>
  )
}
